import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { IPartnerConfig } from "src/constants/interfaces";
import { ISelection } from "src/constants/interfaces/bet";
import { getPrice } from "./priceCalculation";

const getSingleTotalOdd = (config: IClientConfig, prices: number[]) => (!config.enableSingles ? prices[0] : null);
const getMultipleTotalOdd = (config: IClientConfig, prices: number[]) => prices.reduce((acc, item) => acc * item, 1);

const calcTotalOdd = {
	[BetTypeEnum.Single]: getSingleTotalOdd,
	[BetTypeEnum.Multiple]: getMultipleTotalOdd,
	[BetTypeEnum.System]: null,
	[BetTypeEnum.Chain]: null,
	[BetTypeEnum.StraightForecast]: null,
	[BetTypeEnum.StraightTricast]: null,
	[BetTypeEnum.ReverseForecast]: null,
	[BetTypeEnum.CombinationForecast]: null,
	[BetTypeEnum.CombinationTricast]: null,
};

export const checkForOddLimit = (partnerConfig: IPartnerConfig, totalOdd: number) => {
	return totalOdd > partnerConfig.max_odd_for_multiple_bet ? partnerConfig.max_odd_for_multiple_bet : totalOdd;
};

export const getCounterOfferMaxOdd = (partnerConfig: IPartnerConfig, selection: ISelection) => {
	const maxOdd = partnerConfig.odds_raised_percent
		? (selection.event.price / 100) * (100 + partnerConfig.odds_raised_percent)
		: selection.event.price;

	const slicedOdd = Math.floor(maxOdd * 100) / 100;
	return slicedOdd;
};

export const getTotalOdd = (
	config: IClientConfig,
	partnerConfig: IPartnerConfig | undefined,
	betType: BetTypeEnum,
	selections: ISelection[]
) => {
	if (!selections?.length) return null;

	const prices = selections.map(item => getPrice(item));

	const totalOdd = calcTotalOdd[betType]?.(config, prices);

	return totalOdd && partnerConfig ? checkForOddLimit(partnerConfig, totalOdd) : null;
};
